import type { ButtonHTMLAttributes } from "react";

type Variant = "default" | "primary" | "quiet" | "danger";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({ variant = "default", className = "", ...rest }: Props) {
  const classes = ["button", variant !== "default" && `button--${variant}`, className]
    .filter(Boolean)
    .join(" ");
  return <button type="button" className={classes} {...rest} />;
}
